var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.39C0 2.4101 2.4101 0 5.39 0C8.3699 0 10.78 2.4101 10.78 5.39C10.78 9.4325 5.39 15.4 5.39 15.4C5.39 15.4 0 9.4325 0 5.39ZM5.39 1.54C3.2648 1.54 1.54 3.2648 1.54 5.39C1.54 7.5845 3.7884 10.9417 5.39 12.9976C7.0224 10.9263 9.24 7.6076 9.24 5.39C9.24 3.2648 7.5152 1.54 5.39 1.54Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38997 7.31497C6.45311 7.31497 7.31497 6.45311 7.31497 5.38997C7.31497 4.32682 6.45311 3.46497 5.38997 3.46497C4.32682 3.46497 3.46497 4.32682 3.46497 5.38997C3.46497 6.45311 4.32682 7.31497 5.38997 7.31497Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.964d2ac6fbad86e11b64ad2abb13e11e.svg";
export { ForwardRef as ReactComponent };